import { Scale } from "lucide-react";
import "./CommonRightPanel.css"
import { FaDownload } from "react-icons/fa6";
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';
import { store } from "../Store/store";

const CommonRightPanel = ({ isOpen, onClose, data = [] }) => {
    const userInfo = store.getState();

    if (!isOpen) return null;
    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = String(date.getFullYear()).slice(-2); // Last 2 digits of year

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight

        const formattedTime = `${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
        return `${day}-${month}-${year} ${formattedTime}`;
    };

    const formatKey = (key) => {
        const keyLower = key.toLowerCase();
        // Convert camelCase or snake_case to readable format
        if (keyLower.includes('code') || keyLower.includes('id')) {
            return 'Partner Code';
        }
        if (keyLower.includes('ip') || keyLower.includes('address')) {
            return 'IP Address';
        }
        if (keyLower.includes('date') || keyLower.includes('createdon') || keyLower.includes('login')) {
            return 'Created On';
        }
        if (keyLower.includes('user_email')) {
            return 'User Email';
        }
        if (keyLower.includes('phone')) {
            return 'phone-value';
        }

        return 'data-value';
    };

    const formatValue = (key, value) => {
        // Handle different data types and special formatting
        if (value === null || value === undefined) {
            return 'N/A';
        }

        // Date formatting for common date field patterns
        if (typeof value === 'string' &&
            (key.toLowerCase().includes('date') ||
                key.toLowerCase().includes('createdon') ||
                key.toLowerCase().includes('login') ||
                value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/))) {
            try {
                return formatDate(value);
            } catch {
                return value;
            }
        }

        // Convert boolean to readable format
        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        return value.toString();
    };

    const getValueClass = (key, value) => {
        const keyLower = key.toLowerCase();
        const valueLower = value ? value.toString().toLowerCase() : '';

        if (keyLower.includes('code') || keyLower.includes('id')) {
            return 'partner-code';
        }
        if (keyLower.includes('ip') || keyLower.includes('address')) {
            return 'ip-address';
        }
        if (keyLower.includes('date') || keyLower.includes('createdon') || keyLower.includes('login')) {
            return 'created-date';
        }
        if (keyLower.includes('email')) {
            return 'email-value';
        }
        if (keyLower.includes('phone')) {
            return 'phone-value';
        }
        if (keyLower.includes('status')) {
            if (valueLower.includes('active')) return 'status-active';
            if (valueLower.includes('inactive')) return 'status-inactive';
            if (valueLower.includes('pending')) return 'status-pending';
        }

        return 'data-value';
    };

    const downloadExcel = (data) => {
        // Convert JSON data to worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        // Generate buffer
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        // Save the file
        const fileData = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(fileData, "Login_History.xlsx");
    };

    const handleLoginHistoryDownload = () => {

        const exportData = data.map(item => ({
            "Partner Code": item.Partner_Code ? item.Partner_Code : userInfo.userData.Partner_Code,
            "Ip Address": item.IpAddress,
            "User Email": item.User_Email ? item.User_Email : userInfo.userData.EmailId,
            "Created On": formatDate(item.Createdon)
        }));

        downloadExcel(exportData);
    }

    return (
        <>
            {/* Overlay */}
            <div className="right-panel-overlay" onClick={onClose} />

            {/* Panel */}
            <div className="right-panel">
                <div className="right-panel-header">
                    <div className="right-panel-header-content">
                        <h5>Login History</h5>
                        <button type="button" className="btn-close mr-3" onClick={onClose} style={{ transform: 'scale(0.6)' }}></button>
                    </div>
                    <div className="records-count d-flex gap-2 justify-content-center">
                        <p>
                            Showing {data.length} record{data.length !== 1 ? 's' : ''}
                        </p>
                        {data && data.length > 0 &&
                            <p>
                                <FaDownload className="cursor-pointer" onClick={handleLoginHistoryDownload} />
                            </p>
                        }
                    </div>
                </div>

                <div className="right-panel-body">
                    {data && data.length > 0 ? (
                        <>
                            {data.map((item, index) => (
                                <div key={index} className="data-card">
                                    {Object.entries(item).map(([key, value]) => (
                                        value && (
                                            <div key={key} className="data-row">
                                                <>
                                                    <span className="data-label">{formatKey(key)}:</span>
                                                    <span className={getValueClass(key, value)}>
                                                        {formatValue(key, value)}
                                                    </span>
                                                </>
                                            </div>
                                        )
                                    ))}
                                </div>
                            ))}
                        </>
                    ) : (
                        <div className="no-data">
                            <p>No data available</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default CommonRightPanel